export const parseQueryString = (queryString, allowedPaths = []) => {
  const path = queryString.split('?')[0].slice(1);
  if (allowedPaths.length > 0 && !allowedPaths.includes(path)) {
    return [];
  }

  // Remover a parte inicial do caminho
  const params = queryString.split('?')[1];

  // Tratar caso não exista
  if (!params) {
    return [];
  }

  // Split chave e valor
  const paramArray = params.split('&');
  const result = [];

  paramArray.forEach(param => {
    const [key, value] = param.split('=');
    if (key && value) {
      // Evitar duplicidade
      const existingParam = result.find(item => item[key] !== undefined);
      if (existingParam) {
        existingParam[key] = value; // Substituir o array por um valor único
      } else {
        const newParam = {
          [key]: value, // Armazenar como chave-valor
        };
        result.push(newParam);
      }
    }
  });

  return result;
};


export const keyChanges = (obj, keyMapping) => {
  const mappedObj = {};

  for (const key in obj) {
    if (keyMapping[key]) {
      mappedObj[keyMapping[key]] = obj[key];
    } else {
      mappedObj[key] = obj[key];
    }
  }

  return mappedObj;
}


export const combineArrayOfObjects = (array) => {
  const combinedObject = {};

  array.forEach(obj => {
    for (const key in obj) {
      combinedObject[key] = obj[key];
    }
  });

  return combinedObject;
}